import React, { FormEvent, useState } from "react";
import Router, { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import Icon from "@sellernote/ui/src/sds-v1/components/Icon";
import InputText from "@sellernote/ui/src/sds-v1/components/input/InputText";
import Modal from "@sellernote/ui/src/sds-v1/components/Modal";
import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";

import Styled from "./index.styles";

export default function SupportSearch() {
  const { t } = useTranslation(["support-new"]);

  const {
    query: { searchTerm },
  } = useRouter();

  const [localSearchTerm, setLocalSearchTerm] = useState<string | undefined>(
    searchTerm as string
  );

  const [isVisibleNoSearchTermModal, setIsVisibleNoSearchTermModal] =
    useState(false);

  function onSubmit(e: FormEvent<EventTarget>) {
    e.preventDefault();

    if (!localSearchTerm) {
      setIsVisibleNoSearchTermModal(true);
      return;
    }

    Router.push({
      pathname: "/support/search",
      query: { searchTerm: localSearchTerm },
    });
  }

  return (
    <>
      <Styled.container>
        <form onSubmit={onSubmit}>
          <InputText
            borderType="outline"
            valueType="string"
            placeholder={t("support-new:공통_검색")}
            value={localSearchTerm}
            setValue={(val) => setLocalSearchTerm(val as string)}
            clearCB={() => setLocalSearchTerm("")}
            className="search-input"
          />

          <Styled.searchButton>
            <Icon type="search" size={1} color={COLOR.primaryBlue} />
          </Styled.searchButton>
        </form>
      </Styled.container>

      <Modal
        active={isVisibleNoSearchTermModal}
        uiType="titleOnly"
        title={t("support-new:공통_검색어_입력_안내")}
        actionPositive={{
          label: t("support-new:공통_검색어_확인_버튼"),
          handleClick: () => setIsVisibleNoSearchTermModal(false),
        }}
      />
    </>
  );
}
